// When changing this value please remember about changing CSS transition duration accordingly
export const animationDurationMs = 400;
